import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Global Types
import { AppState } from 'services/types';
import {
    MyTimesheetEntryTotalPaidMinutes,
    MyTimesheetEntriesProps
} from 'services/myTimesheetEntries/types';

// Global Selectors
import { makeSelectMyTimesheetEntryTotalPaidMinutes } from 'services/myTimesheetEntries/selectors';

// Global Utils
import minutesToHours from 'utils/minutes-to-hours';

type OwnProps = MyTimesheetEntriesProps;

interface ConnectedProps {
    totalPaidMinutes?: MyTimesheetEntryTotalPaidMinutes;
}

type Props = OwnProps & ConnectedProps;

export class MyTimesheetEntryTotalPaidHoursValue extends React.PureComponent<
    Props
> {
    render(): string | null {
        const { totalPaidMinutes } = this.props;
        if (!totalPaidMinutes) {
            return null;
        }
        return minutesToHours(totalPaidMinutes);
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    totalPaidMinutes: makeSelectMyTimesheetEntryTotalPaidMinutes()
});

export default connect(mapStateToProps)(MyTimesheetEntryTotalPaidHoursValue);
